import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdSenderVerificationSendingDomains =
  "/companies/:company_id/sender_verification/sending_domains";

export const companiesCompanyIdSenderVerificationSendingDomainsCacheKeys: AllRouteEndpoints[] = [];
